import React, { ReactElement} from 'react';
import { Box, Tab, tabClasses, Tabs, Stack, Container } from '@mui/material';
import { styled } from '@mui/styles';
import { useAuth } from '../auth/auth-hook';
import { CustomHeader } from '../../shared/components/layout/CustomHeader';
import { PROJECT_COLOR } from '../../shared/constants';
import { useNavigate } from 'react-router-dom';

type PlanViewProps = {
  children: ReactElement;
};

const ROUTES = [
  {
    path: '/plans',
    name: 'Planes',
  },
  {
    path: '/plans/coupons',
    name: 'Cupones',
  },
];

const ROUTESINFO = [
  {
    path: '/plans/help',
    name: 'Informacion importante',
  },
];

export const PlanViewOnlyLayout: React.FC<
  PlanViewProps
> = ({children}) => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const [currentTwoTab, setCurrentTwoTab] = React.useState(-1);
  const { user } = useAuth();
  const navigate= useNavigate();

  const TabItem = styled(Tab)({
    position: 'relative',
    borderRadius: '30px !important',
    textAlign: 'center',
    transition: 'all .5s',
    padding: '8px 10px !important',
    color: '#BBBBBB',
    height: '35px !important',
    margin: '6px 2px',
    float: 'none',
    lineHeight: '14px',
    fontSize: '14px',
    fontWeight: '700',
    minHeight: '38px',
    textTransform: 'capitalize',
    [`&.${tabClasses.selected}, &:hover`]: {
      color: PROJECT_COLOR ?? '#000000',
      backgroundColor: (PROJECT_COLOR ?? '#000000') + '20 !important',
    },
  });

  const handleChange = (
    event: React.SyntheticEvent | null,
    newValue: number | null,
  ): void => {
    setCurrentTab(newValue ?? 0);
    setCurrentTwoTab(-1);
  };
  const handleChangeTwo = (
    event: React.SyntheticEvent | null,
    newValue: number | null,
  ): void => {
    setCurrentTwoTab(newValue ?? 0);
    setCurrentTab(-1);
  };

  return (
    <>
      <CustomHeader
        title={`Bienvenido de vuelta, ${user?.name}`}
        subtitle={
          'Mide el IMPACTO de tus publicitaciones, registros, choques y tráfico del sitio web.'
        }
      />
      <Container
        maxWidth={'lg'}
        style={{
          borderRadius: '16px',
          padding: '16px 16px',
          background: 'white',
        }}
      >
        <Stack direction="column" width={'100%'} spacing={2}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              paddingBottom: 1,
              display: 'flex',
              justifyContent:'space-between',
              alignItems:'center'
            }}
          >
            <Tabs
              sx={{
                padding: { sm: '0px 10px !important' },

                ['& .MuiTabs-indicator']: {
                  display: 'none !important',
                },
              }}
              value={currentTab}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              allowScrollButtonsMobile
            >
              {ROUTES.map((route, key) => (
                <TabItem
                  key={key}
                  label={route.name}
                  onClick={() => navigate(route.path)}
                />
              ))}
            </Tabs>
            <Tabs
              sx={{
                padding: { sm: '0px 10px !important' },

                ['& .MuiTabs-indicator']: {
                  display: 'none !important',
                },
              }}
              value={currentTwoTab}
              onChange={handleChangeTwo}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              allowScrollButtonsMobile
            >
              {ROUTESINFO.map((route, key) => (
                <TabItem
                  key={key}
                  label={route.name}
                  onClick={() => navigate(route.path)}
                />
              ))}
            </Tabs>
          </Box>
          {children}
        </Stack>
      </Container>
    </>
  );
};
